<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div class="align-self-center">
                  <button
                    v-if="cliente"
                    class="btn btn-light d-flex align-items-center text-dark p-1 border-0"
                    @click="$router.go(-1)"
                  >
                    <i class="nc-icon nc-stre-left font-weight-bold"></i>
                    <p class="m-0 ml-1">Voltar a lista</p>
                  </button>
                </div>
                <div>
                  <button
                    type="submit"
                    class="btn btn-success btn-fill"
                    @click="salvarCliente"
                  >
                    Salvar
                  </button>
                </div>
              </div>
              <div class="text-center" v-if="cliente">
                <div class="mb-1">
                  <label>Código:</label>
                  <span>
                    <strong>{{ ` ${this.cliente.codigo}` }}</strong>
                  </span>
                </div>
                <div class="mb-3">
                  <label>Nome:</label>
                  <span>
                    <strong>{{ ` ${this.cliente.nomeCompleto}` }}</strong>
                  </span>
                </div>
              </div>
              <div class="text-center mb-3" v-if="!codigo">
                <span>
                  <strong>Financeiro Geral</strong>
                </span>
              </div>
              <div class="row">
                <div
                  style="width: 100%;"
                  class="mb-5 d-flex flex-column justify-content-center align-items-center"
                >
                  <label class="mr-2">Data de Pesquisa</label>
                  <div
                    class="row d-flex justify-content-center align-items-center"
                  >
                    <date-picker
                      format="MM/YYYY"
                      v-model="dataDeBusca"
                      type="month"
                      default-value="null"
                    />
                    <button
                      type="submit"
                      class="btn btn-success btn-fill ml-2"
                      @click="buscar"
                    >
                      Buscar
                    </button>
                  </div>
                </div>

                <div class="col-12">
                  <vue-tabs
                    textPosition="center"
                    :centered="true"
                    class="crm-tabs"
                  >
                    <v-tab title="Saídas">
                      <div class="row">
                        <div class="col-12">
                          <div class="overflow-auto">
                            <l-table
                              class="table-hover table-striped"
                              :columns="tabelaSaidas.columns"
                              :data="[
                                ...tabelaSaidas.fixas,
                                ...tabelaSaidas.editaveis
                              ]"
                            >
                              <template slot-scope="{ row, rowIndex }">
                                <td>
                                  <b>{{ row.descricao }}</b>
                                </td>
                                <td>
                                  <div class="input-table">
                                    <base-input
                                      v-model="row.valor"
                                      type="number"
                                      :disabled="row.disabled"
                                    />
                                  </div>
                                </td>
                                <td>
                                  <button
                                    v-if="!row.disabled"
                                    class="btn btn-icon btn-danger"
                                    @click="
                                      deletarSaida(row.descricao, 'saida')
                                    "
                                  >
                                    <i class="fa fa-trash-o"></i>
                                  </button>
                                </td>
                              </template>
                            </l-table>
                          </div>
                          <div class="row">
                            <div class="col-md-3">
                              <base-input
                                label="Descrição"
                                placeholder="Descrição"
                                v-model="dados.descricao"
                              ></base-input>
                            </div>
                            <div class="col-md-3">
                              <base-input
                                label="Valor"
                                placeholder="valor"
                                type="number"
                                v-model="dados.valor"
                              ></base-input>
                            </div>
                            <div class="col-md-1 mt-4">
                              <button
                                class="btn btn-icon btn-success btn-fill"
                                @click="addSaida('saida')"
                              >
                                <i class="fa fa-plus-circle"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-tab>
                    <v-tab title="Entradas">
                      <div class="row">
                        <div class="col-12">
                          <div class="overflow-auto">
                            <l-table
                              class="table-hover table-striped"
                              :columns="tabelaEntradas.columns"
                              :data="[
                                ...tabelaEntradas.fixas,
                                ...tabelaEntradas.editaveis
                              ]"
                            >
                              <template slot-scope="{ row, rowIndex }">
                                <td>
                                  <b>{{ row.descricao }}</b>
                                </td>
                                <td>
                                  <div class="input-table">
                                    <base-input
                                      v-model="row.valor"
                                      type="number"
                                      :disabled="row.disabled"
                                    />
                                  </div>
                                </td>
                                <td>
                                  <button
                                    v-if="!row.disabled"
                                    class="btn btn-icon btn-danger"
                                    @click="deletarSaida(row.descricao)"
                                  >
                                    <i class="fa fa-trash-o"></i>
                                  </button>
                                </td>
                              </template>
                            </l-table>
                          </div>
                          <div class="row">
                            <div class="col-md-3">
                              <base-input
                                label="Descrição"
                                placeholder="Descrição"
                                v-model="dados.descricao"
                              ></base-input>
                            </div>
                            <div class="col-md-3">
                              <base-input
                                label="Valor"
                                placeholder="valor"
                                type="number"
                                v-model="dados.valor"
                              ></base-input>
                            </div>
                            <div class="col-md-1 mt-4">
                              <button
                                class="btn btn-icon btn-success btn-fill"
                                @click="addSaida()"
                              >
                                <i class="fa fa-plus-circle"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-tab>
                  </vue-tabs>
                  <div class="row">
                    <div class="col-md-6">
                      <base-input
                        label="Aval Chefe Departamento"
                        placeholder=""
                        v-model="avalChefeDepartamento"
                      ></base-input>
                      <router-link
                        :to="{
                          name: 'financeiroPDF',
                          params: {
                            ...parametrosPdf,
                            nomeCliente: cliente && cliente.nomeCompleto,
                            codigoCliente: cliente && cliente.codigo,
                            graficos,
                            opcoesGraficoMensal
                          }
                        }"
                      >
                        <button class="btn btn-info mb-4 btn-fill">
                          Visualizar PDF
                        </button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <p class="mt-3 text-center">Balanço</p>
            <bar-chart
              :options="opcoesGraficoMensal"
              v-show="graficos"
              :chart-data="graficos.mensal"
              :style="graficosStyles"
            ></bar-chart>
            <p class="mt-3 text-center" v-if="!codigoCliente">Análise Anual</p>
            <line-chart
              v-if="!codigo"
              :options="opcoesGraficoMensal"
              v-show="graficos"
              :chart-data="graficos.anual"
              :style="graficosStyles"
            ></line-chart>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import LTable from 'src/components/Table.vue';
import PropostaForm from '../Forms/PropostaForm.vue';
import { VueTabs, VTab } from 'vue-nav-tabs';
import FinanceiroService from 'src/services/financeiro';
import vPagination from 'vue-plain-pagination';
import VTooltip from 'v-tooltip';
import Modal from 'src/components/Modal';
import { MENSAGEM_ERRO_DEFAULT } from 'src/utils/constants';
import DatePicker from 'vue2-datepicker';
import BarChart from 'src/components/BarChart';
import LineChart from 'src/components/LineChart';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const colunas = ['Descrição', 'Valor'];
export default {
  components: {
    LTable,
    PropostaForm,
    vPagination,
    VTooltip,
    VueTabs,
    VTab,
    DatePicker,
    Modal,
    BarChart,
    LineChart
  },
  data() {
    return {
      parametrosPdf: {},
      dataDeBusca: new Date(),
      tabelaSaidas: {
        columns: [...colunas],
        editaveis: [
          {
            descricao: 'Material DC',
            valor: ''
          },
          {
            descricao: 'Material AC',
            valor: ''
          },
          {
            descricao: 'Engenharia',
            valor: ''
          },
          {
            descricao: 'Estadia',
            valor: ''
          },
          {
            descricao: 'Alimentação',
            valor: ''
          },
          {
            descricao: 'Logística',
            valor: ''
          },
          {
            descricao: 'Comissão Vendedor',
            valor: ''
          },
          {
            descricao: 'Comissão Design',
            valor: ''
          },
          {
            descricao: 'Imposto',
            valor: ''
          }
        ],
        fixas: []
      },
      dados: {
        descricao: '',
        valor: ''
      },
      tabelaEntradas: {
        columns: [...colunas],
        editaveis: [
          {
            descricao: 'Valor negociado',
            valor: ''
          }
        ],
        fixas: []
      },
      avalChefeDepartamento: '',
      cliente: null,
      codigo: '',
      graficos: {},
      opcoesGraficoMensal: {},
      graficosStyles: {
        height: '300px',
        width: '100%',
        position: 'relative'
      },
      financeiro: {}
    };
  },
  created() {},
  beforeCreate() {},
  mounted() {
    this.codigo = this.$router.history.current.params.codigoDoCliente;
    this.getFinanceiro();
  },
  methods: {
    deletarSaida(descricaoRemover, nomeTabela) {
      if (nomeTabela === 'saida') {
        this.tabelaSaidas.editaveis = this.tabelaSaidas.editaveis.filter(
          item => {
            return item.descricao !== descricaoRemover;
          }
        );
      } else {
        this.tabelaEntradas.editaveis = this.tabelaEntradas.editaveis.filter(
          item => {
            return item.descricao !== descricaoRemover;
          }
        );
      }
    },
    addSaida(nomeTabela) {
      if (nomeTabela === 'saida') {
        if (this.dados.valor && this.dados.descricao) {
          this.tabelaSaidas.editaveis.push(this.dados);
          this.dados = {
            descricao: '',
            valor: ''
          };
        } else {
          this.notify({
            message: 'Favor preencher dados',
            type: 'info'
          });
        }
      } else {
        if (this.dados.valor && this.dados.descricao) {
          this.tabelaEntradas.editaveis.push(this.dados);
          this.dados = {
            descricao: '',
            valor: ''
          };
        } else {
          this.notify({
            message: 'Favor preencher dados',
            type: 'info'
          });
        }
      }
    },
    buscar() {
      if (this.dataDeBusca) {
        this.getFinanceiro();
      } else {
        this.notify({
          message: 'Preencha uma data',
          type: 'danger'
        });
      }
    },
    salvarCliente() {
      const loader = this.createLoading();
      if (this.dataDeBusca) {
        let payload = {
          entradas: this.tabelaEntradas.editaveis,
          saidas: this.tabelaSaidas.editaveis,
          data: this.dataDeBusca.toISOString(),
          avalChefeDepartamento: this.avalChefeDepartamento
        };
        if (this.codigo) {
          FinanceiroService.atualizarFinanceiroCliente(this.codigo, payload)
            .then(() => {
              this.notify({
                message: 'Financeiro do cliente atualizado com sucesso',
                type: 'success'
              });
              this.getFinanceiro();
            })
            .catch(this.showErrorMessage)
            .finally(() => {
              loader.hide();
            });
        } else {
          FinanceiroService.atualizarFinanceiroGeral(payload)
            .then(() => {
              this.notify({
                message: 'Financeiro Geral atualizado com sucesso',
                type: 'success'
              });
              this.getFinanceiro();
            })
            .catch(this.showErrorMessage)
            .finally(() => {
              loader.hide();
            });
        }
      } else {
        this.notify({
          message: 'Preencha uma data',
          type: 'danger'
        });
      }
    },
    getFinanceiro() {
      const loader = this.createLoading();
      if (this.codigo) {
        FinanceiroService.getFinanceiroClienteByCodigo(
          this.codigo,
          this.dataDeBusca
        )
          .then(response => {
            const financeiro = _.get(response, 'data');
            this.preencherDados(financeiro);
            this.cliente = financeiro.cliente;
            this.montarGraficoMensal(financeiro);
          })
          .catch(this.showErrorMessage)
          .finally(() => {
            loader.hide();
          });
      } else {
        FinanceiroService.getFinanceiroGeral(this.dataDeBusca)
          .then(response => {
            const financeiro = _.get(response, 'data');
            this.financeiro = financeiro;
            this.preencherDados(financeiro);
            this.cliente = undefined;

            this.montarGraficoMensal(financeiro);
            this.montarGraficoAnual(financeiro);
          })
          .catch(this.showErrorMessage)
          .finally(() => {
            loader.hide();
          });
      }
    },
    showErrorMessage(error) {
      const message = _.has(error, 'response.data.message')
        ? _.get(error, 'response.data.message')
        : MENSAGEM_ERRO_DEFAULT;

      this.notify({
        message,
        type: 'danger'
      });
      this.$router.replace('');
    },
    preencherDados(dados) {
      this.avalChefeDepartamento = dados.avalChefeDepartamento;
      this.tabelaSaidas.editaveis = dados.saidas;
      this.tabelaEntradas.editaveis = dados.entradas;
      this.parametrosPdf = dados;
      if (dados.entradasClientes) {
        this.tabelaEntradas.fixas = dados.entradasClientes.map(entrada => ({
          descricao: entrada.descricao,
          valor: entrada.valor.$numberDecimal,
          disabled: true
        }));
      } else {
        this.tabelaEntradas.fixas = [];
      }

      if (dados.saidasClientes) {
        this.tabelaSaidas.fixas = dados.saidasClientes.map(saida => ({
          descricao: saida.descricao,
          valor: saida.valor.$numberDecimal,
          disabled: true
        }));
      } else {
        this.tabelaSaidas.fixas = [];
      }
    },
    createLoading() {
      return this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
    },
    montarGraficoMensal(financeiro) {
      let somaEntradas = 0;
      let somaSaidas = 0;
      if (
        financeiro.entradasClientes &&
        financeiro.entradasClientes.length > 0
      ) {
        const somaEntradasClientes = financeiro.entradasClientes.reduce(
          (acc, curr) => acc + parseFloat(curr.valor.$numberDecimal),
          0
        );
        somaEntradas = somaEntradasClientes;
      }

      if (financeiro.saidasClientes && financeiro.saidasClientes.length > 0) {
        const somaSaidasClientes = financeiro.saidasClientes.reduce(
          (acc, curr) => acc + parseFloat(curr.valor.$numberDecimal),
          0
        );
        somaSaidas = somaSaidasClientes;
      }
      if (financeiro.somaEntradas && financeiro.somaEntradas.$numberDecimal) {
        somaEntradas += parseFloat(financeiro.somaEntradas.$numberDecimal);
      }
      if (financeiro.somaSaidas && financeiro.somaSaidas.$numberDecimal) {
        somaSaidas += parseFloat(financeiro.somaSaidas.$numberDecimal);
      }
      this.graficos.mensal = {
        labels: ['Entrada', 'Saída', 'Receita'],
        datasets: [
          {
            label: '',
            backgroundColor: 'blue',
            data: [somaEntradas, somaSaidas, somaEntradas - somaSaidas]
          }
        ]
      };
      this.opcoesGraficoMensal = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true
          },
          x: {
            beginAtZero: true
          }
        }
      };
    },
    montarGraficoAnual(financeiro) {
      let entradas = [...Array(12).keys()];
      let saidas = [...Array(12).keys()];
      let receitas = [...Array(12).keys()];
      if (financeiro.relatorioAnual) {
        financeiro.relatorioAnual.forEach((mes, index) => {
          entradas[index] = mes.somaEntradas;
          saidas[index] = mes.somaSaidas;
          receitas[index] = mes.somaEntradas - mes.somaSaidas;
        });
      }
      this.graficos.anual = {
        labels: [...Array(12).keys()].map(i => i + 1),
        datasets: [
          {
            label: 'Entrada',
            backgroundColor: 'blue',
            borderColor: 'blue',
            data: entradas,
            fill: false,
            tension: 0.1
          },
          {
            label: 'Saida',
            backgroundColor: 'red',
            borderColor: 'red',
            data: saidas,
            fill: false,
            tension: 0.1
          },
          {
            label: 'Receita',
            backgroundColor: 'green',
            borderColor: 'green',
            data: receitas,
            fill: false,
            tension: 0.1
          }
        ]
      };

      this.opcoesGraficoMensal = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true
          },
          x: {
            beginAtZero: true
          }
        }
      };
    },
    notify({ type, message }) {
      let icon = '';
      switch (type) {
        case 'info':
          icon = 'fa fa-info';
          break;
        case 'success':
          icon = 'fa fa-check';
          break;
        case 'danger':
          icon = 'fa fa-exclamation-triangle';
      }
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: type
      });
    }
  },
  watch: {
    '$route.path': function() {
      this.codigo = this.$router.history.current.params.codigoDoCliente;
      this.getFinanceiro();
    }
  }
};
</script>
<style scoped>
.input-table {
  justify-content: center;
  align-content: center;
  width: 40%;
}
.height-fit-content {
  height: fit-content;
}
.crm-tabs .nav {
  display: block !important;
}

.garantias {
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
}
</style>
